import React from "react";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import { Sidebar } from "../components/Sidebar";
import axios from "axios";
import Spinner from "../components/Spinner";
import { Chart, registerables } from "chart.js";
import { Bar, Pie } from "react-chartjs-2";

Chart.register(...registerables);

const API = localStorage.getItem("assethost");

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: true,
      msg: "",
      toastColor: "",
      // Flattened dashboard state
      totalAssets: 0,
      // AccountStatus flattened
      companyAccountActive: "",
      accountStatusExpiryDate: "",
      subscriptionName: "",
      accountStatusCost: 0,
      // BalanceView flattened
      bundleName: "",
      credits: 0,
      balanceExpiryDate: "",
      balanceCost: 0,
      used: 0,
      // SystemMessages as array of flat objects
      systemMessages: [],
      // ChartDetails as array of flat chart objects
      chartDetails: [],
    };
    this.loadDashboard = this.loadDashboard.bind(this);
    this.safeText = this.safeText.bind(this);
  }

  safeText(v) {
    return v === null || v === undefined || v === "" ? "-" : String(v);
  }

  componentDidMount() {
    this.loadDashboard();
  }

  loadDashboard() {
    const token = sessionStorage.getItem("token");
    const companyProfileId = sessionStorage.getItem("companyProfileId");
    const individualProfileId = sessionStorage.getItem("individualProfileId");
    const lawEnforcementProfileId = sessionStorage.getItem(
      "lawEnforcementProfileId"
    );
    const isPaidService =  sessionStorage.getItem("isPaidService");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }

    if (!companyProfileId && !individualProfileId && !lawEnforcementProfileId) {
      this.setState({
        loading: false,
        msg: "No profile ID found. Please login again.",
        toastColor: "danger",
      });
      return;
    }

    const requestBody = {
      companyProfileId: companyProfileId ? parseInt(companyProfileId) : null,
      individualProfileId: individualProfileId
        ? parseInt(individualProfileId)
        : null,
      lawEnforcementProfileId: lawEnforcementProfileId
        ? parseInt(lawEnforcementProfileId)
        : null,
        isPaidService: isPaidService
    };

    axios
      .post(API + "/home/getdashboard", requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        const chartDetails = data.chartDetails || [];
        const accountStatus = data.accountStatus || {};
        const balanceView = data.balanceView || {};
        const systemMessages = data.systemMessages || [];

       
      
        // Flatten accountStatus
        const flattenedAccountStatus = {
          companyAccountActive: accountStatus.companyAccountActive || "",
          expiryDate: accountStatus.expiryDate || "",
          subscriptionName: accountStatus.subscriptionName || "",
          cost: accountStatus.cost || 0,
        };

        // Flatten balanceView
        const flattenedBalance = {
          bundleName: balanceView.bundleName || "",
          credits: balanceView.credits || 0,
          expiryDate: balanceView.expiryDate || "",
          cost: balanceView.cost || 0,
          used: balanceView.used || 0,
        };

        this.setState({
          loading: false,
          totalAssets: data.totalAssets || 0,
          companyAccountActive: flattenedAccountStatus.companyAccountActive,
          accountStatusExpiryDate: flattenedAccountStatus.expiryDate,
          subscriptionName: flattenedAccountStatus.subscriptionName,
          accountStatusCost: flattenedAccountStatus.cost,
          bundleName: flattenedBalance.bundleName,
          credits: flattenedBalance.credits,
          balanceExpiryDate: flattenedBalance.expiryDate,
          balanceCost: flattenedBalance.cost,
          used: flattenedBalance.used,
          systemMessages,
          chartDetails: chartDetails,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
          sessionStorage.clear();
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load dashboard.",
          toastColor: "danger",
        });
      });
  }
redirectTo(link)
  {
    window.location = link
  }
  render() {
    const s = this.state;

    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    // Render system messages as alerts
    const systemMessagesDivs = s.systemMessages.map((msg, index) => (
      <div key={index} className="alert alert-danger mx-7 mb-2">
        <div className="row">
         <div className="col">{msg.message}</div>  
         <div className="col">{msg.systemMessageType === 'MISSING_IDENTITY_DOCUMENTS' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/upload-documents')}
            >
              Update Missing Details
            </button>}
            {msg.systemMessageType === 'CERTFICATE_OF_INCORPATION' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/upload-documents')}
            >
              Update Missing Details
            </button>}
            
            {msg.systemMessageType === 'CR14' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/upload-documents')}
            >
              Update Missing Details
            </button>}
             {msg.systemMessageType === 'MISSING_IDENTITY_DOCUMENTS_COMPANY' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/upload-documents')}
            >
              Update Missing Details
            </button>} {msg.systemMessageType === 'SUBSCRIPTION' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/billing/account')}
            >
              Update Subscription
            </button>} {msg.systemMessageType === 'BALANCE' && <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/billing/account')}
            >
             Top Up Account
            </button>}
            </div>
            </div>
      </div>
    ));

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex bg-white">
        <Sidebar />
        <div className="min-h-screen grow flex flex-col">
          <Banner title="Dashboard" />
          {divMsg}
          {systemMessagesDivs}
          <div className="rounded-b flex justify-center grow overflow-y-auto">
            <div className="w-full h-full flex px-6">
              {/* Charts */}
              <div className="grid grid-cols-2 justify-center w-[80%]">
                {!!s.chartDetails &&
                  !!s.chartDetails.length &&
                  s.chartDetails.map((detail) => (
                    <div
                      className="flex flex-col items-center"
                      key={detail.title}
                    >
                      <div class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded">
                     <h3 class="font-bold text-blue-800 mb-2">
                        {detail.title}
                      </h3>
                      <div className="w-[400px] h-[400px]">
                        {detail.chartType === "BAR" ? (
                          <Bar
                            datasetIdKey={detail.title}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              width: 400,
                              height: 400,
                            }}
                            height={400}
                            width={400}
                           data={detail.chart}
                          />
                        ) : (
                          <Pie
                            datasetIdKey={detail.title}
                            options={{
                              responsive: true,
                              maintainAspectRatio: false
                            }}
                            height={400}
                            width={400}
                            data={detail.chart}
                          />                          
                        )}
                      </div>
                      </div>
                    </div>
                  ))}
              </div>
              {/* Right stats */}
              <div className="flex justify-center w-[20%]">
                <div className="flex gap-1 border-b pb-2">
                  <div class="p-4 border border-blue-200 rounded">
                  <span className="font-bold">Total Assets: </span>
                  {this.safeText(s.totalAssets)}
                  </div>
                </div>        
                {s.credits > 0 && sessionStorage.getItem("isPaidService") === 'YES' && (
                  <div className="flex gap-1 border-b pb-2">
                    <div class="p-4 border border-blue-200 rounded">
                    <div className="row">
                   <div className="col"><span className="font-bold">Name:</span>
                    {this.safeText(s.bundleName)} <span className="font-bold">Available Credits:</span>
                    {this.safeText(s.credits)}</div>
                    </div>
                  <div className="row">
                  <div className="col"><button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/billing/account')}
            >
             View Account
            </button></div>

                    </div> 
                    </div> 
                  </div>
                )}  
                {s.companyAccountActive === 'YES' && 
                         <div className="flex gap-1 border-b pb-2">
                    <div class="p-4 border border-blue-200 rounded">
                    <div className="row">
                   <div className="col"> <span className="font-bold">Name:</span>
                    {this.safeText(s.subscriptionName)}  <span className="font-bold">Expiry:</span>
                    {this.safeText(s.expiryDate)}</div>
                    </div>
                  <div className="row">
                  <div className="col"><button
              type="button"
              className="btn btn-danger"
              onClick={() => this.redirectTo('/billing/account')}
            >
             View Account
            </button></div>

                    </div> 
                    </div> 
                  </div>    
                }
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
